<template>
  <div class="my">
    <div class="my-title">关于我们</div>
      <div class="my-box">
        <div class="my-box-left">
          <img src="@/assets/imgs/my-img.png" alt="">
        </div>
        <div class="my-box-right">
          <div class="my-box-right-title">深圳市轻松信息科技有限公司 </div>
          <p class="my-box-right-text">深圳轻松由一支热爱并高度理解的音乐软件开发服务专业团队组成，拥有音乐软件开发领域实战经验，百余人专业团队，以不拘一格的人才战略和综合的资源体系运作，高度践行集团战略，助力客户价值升级。</p>
          <p class="my-box-right-text">深圳市轻松信息科技有限公司，以高度的战略格局和敏锐的商业嗅觉，专注于为客户提供音乐移动互联网软件定制开发服务。业务范围涵盖软件开发、应用软件定制、微信开发、产品设计规划等专业服务。</p>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'my',
}
</script>
<style scoped>
.my {
  width: 100%;
  height: 100%;
  padding: 0 360px;
}
.my-title {
  font-size: 24PX;
  line-height: 59px;
  border-bottom: 2px #BAA364 solid;
  margin-bottom: 60px;
}
img {
  width: 100%;
  height: 100%;
}
.my-box {
  width: 100%;
  margin-bottom: 100px;
  display: flex;
  justify-content: space-between;
}
.my-box-left {
  width: 50%;
}
.my-box-right {
  width: 50%;
  padding: 40px 30px;
  background-color: #F3F3F3;
}
.my-box-right-title {
  font-size: 30px;
  line-height: 30px;
  margin-bottom: 45px;
}
.my-box-right-text {
  font-size: 18PX;
  line-height: 30px;
  text-indent: 2rem;
  margin-bottom: 10px;
  text-align: justify;
}
</style>
